import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import StatusViewEditComponent from "../../components/statusViewEditComponent";
import { toast } from "react-toastify";
import DeleteModal from "../../../../../Components/Common/DeleteModal";

import {
  createFoodDietType,
  createFoodDietTypeSuccess,
  deleteFoodDietType,
  deleteFoodDietTypeSuccess,
  getFoodDietTypeList,
  updateFoodDietType,
  updateFoodDietTypeSuccess,
} from "../../../../../store/products/action";

export default function FoodDietType() {
  const dispatch = useDispatch();
  const { foodDietTypeListSuccessAPI } = useSelector((state) => ({
    foodDietTypeListSuccessAPI:
      state.Products.foodDietTypeList?.fooddiettype_list,
  }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Diet Type",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      dispatch(createFoodDietType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = foodDietTypeListSuccessAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [foodDietTypeListSuccessAPI, activeTab]);

  useEffect(() => {
    dispatch(getFoodDietTypeList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      dispatch(deleteFoodDietType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        dispatch(updateFoodDietType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createFoodDietTypeSuccessAPI,
    updateFoodDietTypeSuccessAPI,
    deleteFoodDietTypeSuccessAPI,
  } = useSelector((state) => ({
    createFoodDietTypeSuccessAPI: state.Products.createFoodDietTypeSuccess,
    updateFoodDietTypeSuccessAPI: state.Products.updateFoodDietTypeSuccess,
    deleteFoodDietTypeSuccessAPI: state.Products.deleteFoodDietTypeSuccess,
  }));

  // Add New response
  useEffect(() => {
    if (isEmpty(createFoodDietTypeSuccessAPI)) return;
    if (createFoodDietTypeSuccessAPI?.status === 200) {
      toast.success(createFoodDietTypeSuccessAPI?.message);
      dispatch(getFoodDietTypeList());
    } else {
      toast.error(createFoodDietTypeSuccessAPI?.message);
    }
    dispatch(createFoodDietTypeSuccess([]));
  }, [createFoodDietTypeSuccessAPI]);

  // Update response
  useEffect(() => {
    if (isEmpty(updateFoodDietTypeSuccessAPI)) return;
    if (updateFoodDietTypeSuccessAPI?.status === 200) {
      toast.success(updateFoodDietTypeSuccessAPI?.message);
      dispatch(getFoodDietTypeList());
    } else {
      toast.error(updateFoodDietTypeSuccessAPI?.message);
    }
    dispatch(updateFoodDietTypeSuccess([]));
  }, [updateFoodDietTypeSuccessAPI]);

  // Delete response
  useEffect(() => {
    if (isEmpty(deleteFoodDietTypeSuccessAPI)) return;
    if (deleteFoodDietTypeSuccessAPI?.status === 200) {
      toast.success(deleteFoodDietTypeSuccessAPI?.message);
      dispatch(getFoodDietTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteFoodDietTypeSuccessAPI?.message);
    }
    dispatch(deleteFoodDietTypeSuccess([]));
  }, [deleteFoodDietTypeSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}
      <Row className="row align-items-end mt-3"></Row>
      <Row>
        <Col lg={12}>
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            statusFlag={statusFlag}
          />
        </Col>
      </Row>
    </>
  );
}
